import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import API from '../../api.js';
import Tools from '../../tools';
import ListView from '../utils/ListView';
import { withRouter } from 'react-router-dom';

class AdsApp extends Component {
    constructor() {
        super();
        Tools.init();
        API.init(this);

        this.state = {
            ty: 0,
            list: [],
            page_max: 20,
            filter: null,
            list_index_min: 0,
            list_index_max: 20,
            page_index: 0,
            fields: [
                "廣告編號",
                "廣告標題",
                "廣告類型",
                "上架日期",
                "下架日期",
                "總點擊次數",
                "總點擊人數"
            ]
        };
        this.getData();
        this.onListViewClicked = this.onListViewClicked.bind(this);
    }
    getData() {
        var tmpData = {
            ty: this.state.ty
        };
        API.GetAds(tmpData, this.onDataUpdated.bind(this));
    }

    onListViewClicked(index) {
        console.log(index);
        // location.href = "detail.html?id="+index;
        let path = '/#/ads/detail/' + index;
        // this.props.history.push(path);
        window.open(path);
    }

    onDataUpdated(data) {
        console.log(this);
        if (data && data.data) {
            console.log(data);
            const tmp = [];
            /* {
                "end_at": "1561910400000",
                "is_recom": "0",
                "gid": "GL181018163502",
                "ad_type": "3",
                "icon": "gifts/261/cgqt1paxiscbrc2tcyca6xzixn0pkigl.jpg",
                "link": "none",
                "description": "none",
                "created_at": "1543563890473",
                "total_members": 0,
                "pid": "none",
                "source": "dataa",
                "video": "none",
                "type": "1",
                "start_at": "1543104000000",
                "point": "0",
                "has_video": "0",
                "images2": [],
                "adid": "AD181130154450",
                "updated_at": "1543563890473",
                "is_del": "0",
                "total_clicks": 0,
                "add_desc": "none",
                "images": [],
                "sub_name": "none",
                "is_top": "0",
                "created_id": "admin",
                "name": "歡樂美味盡在EZChoice",
                "cash_point": "0",
                "updated_id": "admin"
            } */
            for (let index in data.data) {
                const tmpObj = data.data[index];
                // "廣告編號",
                // "廣告標題",
                // "廣告類型",
                // "上架日期",
                // "下架日期",
                // "總點擊次數",
                // "總點擊人數"
                tmp.push({
                    key: tmpObj.adid,
                    data: [
                        tmpObj.adid,
                        tmpObj.name,
                        tmpObj.type,
                        Tools.getFormatDate(tmpObj.start_at),
                        Tools.getFormatDate(tmpObj.end_at),
                        tmpObj.total_clicks,
                        tmpObj.total_members
                    ]
                });
            }
            this.setState({
                list: tmp
            })
        }
    }
    render() {
        const { list, fields } = this.state,
            onListViewClicked = this.onListViewClicked;
        return (
            <div className="container-fluid py-md-3">
                <ListView list={list}
                    fields={fields}
                    title={"廣告列表"}
                    onRowClicked={onListViewClicked} />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(AdsApp))